import { Box, Flex, Input, Switch, Text } from '@chakra-ui/react';
import _ from 'lodash';
import { BaseSyntheticEvent, Fragment, useEffect, useState } from 'react';
import { useInfiniteQuery } from 'react-query';

import { InfiniteScroll } from '../InfiniteScroll';

import NotificationItem from './NotificationItem';

import { getNotifications } from '@/api';
import socket from '@/api/socket';

const TAKE = 10;

export const NotificationScroll = ({ onClose }) => {
  const [numberConlitation, setNumberConlitation] = useState<number | undefined>();
  const [fileNumber, setFileNumber] = useState<string | undefined>();
  const [alreadyReadNotifications, setAlreadyReadNotifications] = useState<boolean>(true);

  const { data, fetchNextPage, refetch } = useInfiniteQuery(
    ['/notifications', numberConlitation, fileNumber, alreadyReadNotifications],
    ({ pageParam = 0 }) =>
      getNotifications({
        skip: pageParam * TAKE,
        take: TAKE,
        numberComlicitacaoSearch: numberConlitation,
        fileNumber,
        enabled: alreadyReadNotifications,
      }),
    {
      getNextPageParam: (lastPage, allPages) => {
        const maxPages = lastPage.totalItems / 10;
        const nextPage = allPages.length;
        return nextPage <= maxPages ? nextPage : undefined;
      },
    },
  );

  const newNotifications = data?.pages.flatMap((page) => page.data) ?? [];

  useEffect(() => {
    const handleNewNotification = refetch;

    socket.on('new-notification', handleNewNotification);

    return () => {
      socket.off('new-notification', handleNewNotification);
    };
  }, [refetch]);

  return (
    <Box>
      <Flex
        alignItems="center"
        gap="4"
        py="2"
        px="4"
        color="gray.700"
        fontWeight="semibold"
        mb="4"
        borderRadius="md"
      >
        <Text>Notificações já lidas</Text>
        <Switch
          value={String(!alreadyReadNotifications)}
          onChange={(e) => {
            setAlreadyReadNotifications(() => {
              return !e.target.checked;
            });
          }}
        />
      </Flex>
      <Input
        mb="1rem"
        type="text"
        maxLength={8}
        onInput={(e) => {
          const event = e as unknown as BaseSyntheticEvent<HTMLInputElement>;
          if (event.target.value) {
            event.target.value = event.target.value.replace(/[^0-9]/g, '');
          }
        }}
        placeholder="Número da conlicitação"
        onChange={_.debounce(({ target: { value } }) => {
          if (value === '') {
            setNumberConlitation(undefined);
          } else {
            setNumberConlitation(Number(value));
          }
        }, 400)}
      />
      <Input
        mb="2rem"
        type="text"
        maxLength={8}
        onInput={(e) => {
          const event = e as unknown as BaseSyntheticEvent<HTMLInputElement>;
          if (event.target.value) {
            event.target.value = event.target.value.replace(/[^0-9]/g, '');
          }
        }}
        placeholder="Número da certidão"
        onChange={_.debounce(({ target: { value } }) => {
          if (value === '') {
            setFileNumber(undefined);
          } else {
            setFileNumber(value);
          }
        }, 400)}
      />
      <InfiniteScroll
        display="block"
        maxH="60vh"
        overflowY="auto"
        onEndReached={_.debounce(fetchNextPage, 500)}
      >
        {newNotifications.map((notification, index) => (
          <Fragment key={`${notification.id}-${index}`}>
            <NotificationItem onClose={onClose} notification={notification} />
          </Fragment>
        ))}
      </InfiniteScroll>
    </Box>
  );
};
